import request from '@/utils/request'
const qs = require('qs')
export function listDataMasterPromo(data) {
  return request({
    url: '/master_promo/list_data_master_promo',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/reportMasterPromo.js